<template>
    <v-app id="inspire">
      <v-navigation-drawer v-model="drawer">
        <v-list-item>
          <v-list-item-title class="title text-center pt-12 pb-9">
            <a href="/" style="font-size: 18px; text-decoration: none;" :class="{ 'dark': isDark, 'light-link': !isDark }">{{ apptitle }}</a>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
  
        <v-list dense nav>
          <v-list-item v-for="item in items" :key="item.title" :to="item.to" link>
              <template v-slot:prepend>
                <svg-icon type="mdi" :path="item.path" class="mr-3"></svg-icon>
              </template>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
  
      </v-navigation-drawer>
  
      <v-app-bar
          app
          dark 
          prominent 
          color="teal-darken-2" 
          height="120"
          image="top_pict.jpg"
      >
          <!-- Image slot -->
          <template v-slot:image>
              <v-img gradient="to top right, rgba(19,84,122,.8), rgba(128,208,199,.8)"></v-img>
          </template>

          <!-- Prepend slot -->
          <template v-slot:prepend>
              <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
          </template>

          <!-- Title slot -->
          <v-app-bar-title><a href="/" style="font-size: 24px; text-decoration: none; color: #EEE;">{{ apptitle }}</a></v-app-bar-title>

          <!-- Spacer -->
          <v-spacer></v-spacer>

          <!-- Temaskifter -->
          <v-tooltip text="Temaskift" location="top">
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" icon @click="toggleTheme" class="theme-change"><svg-icon type="mdi" :path="mdiThemeLightDark"></svg-icon></v-btn>
            </template>
          </v-tooltip>

          <!-- Avatar -->
          <v-tooltip text="Account" location="top">
            <template v-slot:activator="{ props }">
              <v-avatar v-bind="props" color="primary" size="36px">
                {{ userInitials }}  
              </v-avatar>
            </template>
          </v-tooltip>

          <!-- Tooltip with Logout button -->
          <v-tooltip text="Logout" location="top">
            <template v-slot:activator="{ props }">
              <!-- Updated logout icon -->
              <v-btn v-bind="props" icon @click="handleLogout"><svg-icon type="mdi" :path="mdiLogout"></svg-icon></v-btn>
            </template>
          </v-tooltip>
      </v-app-bar>
  
      <v-main>
        <router-view></router-view>
      </v-main>
    </v-app>
  </template>
  
  <script setup>
    import { ref, computed } from 'vue';
    import { useTheme } from 'vuetify';
    import { useStore } from 'vuex';
    import { useRouter } from 'vue-router';
    import SvgIcon from '@jamescoyle/vue-icon';
    import { 
      mdiThemeLightDark, 
      mdiLogout,
      mdiMonitorDashboard, 
      mdiNumeric, 
      mdiTagSearchOutline, 
      mdiArchiveSearchOutline, 
      mdiInformationVariant,
      mdiRecycleVariant,
      mdiFolderDownload,
      mdiFolderUpload 
    } from '@mdi/js';  

    // --- State and Refs ---
    const drawer = ref(null);
    const theme = useTheme();
    const store = useStore();
    const router = useRouter();
    const isDark = ref(localStorage.getItem('theme') === 'dark');
    const apptitle = process.env.VUE_APP_NAME;

    // --- Menu Items ---
    const items = ref([
      { title: "Main menu", path: mdiMonitorDashboard, to: "/" },
      { title: "Create series", path: mdiNumeric, to: "/purchases" },
      { title: "Search Serials", path: mdiTagSearchOutline, to: "/serial-search" },
      { title: "Search Boxes", path: mdiArchiveSearchOutline, to: "/box-search" },
      { title: "Reuse series", path: mdiRecycleVariant, to: "/reuse-serials" },
      { title: "Download Files", path: mdiFolderDownload, to: "/filemanager" },
      { title: "Upload Files", path: mdiFolderUpload, to: "/upload-files" },
      { title: "About", path: mdiInformationVariant, to: "/about" },
    ]);

    // --- Computed Properties ---
    const userInitials = computed(() => {
      const realname = localStorage.getItem('username') || '';
      return realname
        .split(' ')
        .map(name => name.charAt(0))
        .join('');
    });

    // --- Methods ---

    // Function to toggle the theme
    const toggleTheme = () => {
      isDark.value = !isDark.value;
      const newTheme = isDark.value ? 'dark' : 'light';
      
      // Update theme choice
      theme.global.name.value = newTheme;
      localStorage.setItem('theme', newTheme);
    };

    // Logout handler
    const handleLogout = async () => {
      console.log('handleLogout method called'); 
      try {
        await store.dispatch('auth/logout'); // Replaced mapActions
        router.push({ name: 'login' }); 
      } catch (error) {
        console.error('Error logging out:', error);
      }
    };
  </script>
  
  <style scoped>
    .light-link {
      color: #333; /* Or your light theme link color */
    }
    .dark-link {
      color: #FFF; /* Or your dark theme link color */
    }
  </style>
